<button
    type="button"
    class="ots-staff-filter d-flex align-items-center justify-content-center position-relative c-t-blue-900 base-border-radius"
    [class.c-bg-blue-200]="!filtersActive"
    [class.c-bg-blue-300]="filtersActive"
    width="36px"
    height="36px"
    [attr.aria-expanded]="isFilterMenuOpen()"
    [attr.aria-label]="'Filters' | trans:'ots.staff.filters'"
    (click)="toggleFilterMenu($event)"
  >
    <i class="ri-equalizer-line icon-sm" aria-hidden="true"></i>
    @if (filtersActive) {
      <span
        class="ots-staff-filter__badge position-absolute c-bg-blue-700 border-radius-100 pointer-events-none"
        aria-hidden="true"
      ></span>
    }
  </button>
  @if (isFilterMenuOpen()) {
    <div
      class="ots-staff-filter-menu position-absolute c-bg-gray-100 medium-border-radius"
      role="menu"
      [attr.aria-label]="'Status' | trans:'ots.staff.filters.status'"
    >
      <div class="ots-staff-filter-menu__header p-y-12 p-x-16 fw-medium text-uppercase c-t-blue-900">
        {{ 'Status' | trans:'ots.staff.filters.status' }}
      </div>
      <ul class="ots-staff-filter-menu__list p-8">
        @for (option of options; track option.id) {
          <li>
            <button
              type="button"
              class="ots-staff-filter-menu__option full-width d-flex align-items-center gap-12 text-left base-border-radius"
              role="menuitemcheckbox"
              [attr.aria-checked]="option.checked"
              (click)="toggleStatus(option.id)"
            >
              <span
                class="ots-staff-filter-menu__check d-flex align-items-center justify-content-center"
                [class.is-checked]="option.checked"
                [class.c-bg-gray-100]="!option.checked"
                [class.c-bg-blue-700]="option.checked"
                [class.c-t-gray-100]="option.checked"
                aria-hidden="true"
              >
                @if (option.checked) {
                  <i class="ri-check-line"></i>
                }
              </span>
              <span class="p3 c-t-blue-900">{{ option.label }}</span>
            </button>
          </li>
        }
      </ul>
    </div>
  }
